var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M8.55906 3.83984V18.1698C8.21906 18.1798 7.87906 18.2598 7.62906 18.4098L5.27906 19.7498C3.63906 20.6898 2.28906 19.9098 2.28906 18.0098V8.27984C2.28906 7.64984 2.73906 6.86984 3.29906 6.54984L7.62906 4.06984C7.87906 3.92984 8.21906 3.84984 8.55906 3.83984Z",
    fill: "#314DDF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7305 6.82994V21.1599C15.3805 21.1699 15.0405 21.1099 14.7705 20.9799L9.52055 18.3499C9.25055 18.2199 8.91055 18.1599 8.56055 18.1699V3.83994C8.91055 3.82994 9.25055 3.88994 9.52055 4.01994L14.7705 6.64994C15.0405 6.77994 15.3805 6.83994 15.7305 6.82994Z",
    fill: "#314DDF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M22.0005 6.99006V16.7201C22.0005 17.3501 21.5505 18.1301 20.9905 18.4501L16.6605 20.9301C16.4105 21.0701 16.0705 21.1501 15.7305 21.1601V6.83006C16.0705 6.82006 16.4105 6.74006 16.6605 6.59006L19.0105 5.25006C20.6505 4.31006 22.0005 5.09006 22.0005 6.99006Z",
    fill: "#314DDF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.5a07b824e1f93d72506ed2a02375683b.svg";
export { ForwardRef as ReactComponent };